import React, { useEffect } from "react";
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layout/Layout';
import HomePage from './pages/HomePage';
import LoginButton from "./pages/LoginButton";
import Contact from "./pages/Contact";
import About from "./pages/About";
import SignupButton from "./pages/SignupButton";
import AssesmentDash from "./pages/AssesmentDash";
import ProtectedRoute from "./services/ProtectedRoute";
import Participants from "./pages/Dashboard/Participants";
import { ParentComponent } from "./pages/Dashboard/parentSeflAssesment";
import ReportPage from "./pages/Dashboard/ReportPage";
import Details from "./pages/Dashboard/participantDetails";
import NewAssessment from "./pages/Dashboard/NewAssessment";
import ScrollToTop from "./services/ScrollToTop";
import ForgotPassword from "./pages/ForgotButton";
import AdminDashboard from "./components/admin/Admin";
import NotFoundPage from "./components/admin/Notfound";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Campaigns from "./components/admin/UserCampaigns/UserCampaigns";
import CampaignDetails from "./components/admin/CampaignDetails/CampaignDetails";
import AssessmentRoute from "./services/AssessmentRoute";

window.console.log = () => {};
const App = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: false // whether animation should happen only once - while scrolling down
    });
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>

          <Route index element={<HomePage />} />
          <Route path="/login" element={<LoginButton />} />
          <Route path="/signup" element={<SignupButton />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />

          <Route element={<ProtectedRoute />}>

            <Route path="/user/:userId/campaigns" element={<Campaigns />} />
            
            <Route path="/campaign/:campaignId/details" element={<CampaignDetails />} />


            <Route path="/assessment" element={<AssesmentDash />} />
            <Route path="/start-asmt" element={<NewAssessment />} />
            <Route path="/self-asmt/:encodedId" element={<ParentComponent />} />
            <Route path="/conn-asmt/:encodedId" element={<Participants />} />
            <Route path="/participant/:encodedId" element={<ParentComponent name="participant" />} />
            {/* <Route path="/report/:encodedId" element={<ReportPage />} /> */}
            <Route path="/report/:encodedId" element={<AssessmentRoute><ReportPage /></AssessmentRoute>} />
            <Route path="participant-details/:encodedId" element={<Details />} />
            {/* </ScrollToTop> */}
          </Route>

          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFoundPage />} /> {/* Catch-all route */}

        </Route>
      </Routes>
    </Router>
  );
};

export default App;
